<template>
    <transition
        @appear="intro"
        @enter="intro"
        @leave="outro"
        :css="false"
        appear=""
    >
        <div class="Auction">
            <auction-modal v-show="visible"></auction-modal>
            <close-link :to="closeTo"></close-link>
        </div>
    </transition>
</template>

<script>
import AuctionModal from "@/app/components/AuctionModal";
import CloseLink from "@/app/components/CloseLink";
import * as routes from "@/app/routes";

export default {
    name: 'Auction',
    components: {
        AuctionModal,
        CloseLink
    },
    data: () => ({
        visible: false,
    }),
    computed: {
        closeTo() {
            return {
                name: routes.CHAPTER
            }
        }
    },
    methods: {
        intro(el, done) {
            this.visible = true
            TweenMax.fromTo(el, 2, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: done
            });
        },
        outro(el, done){
            this.visible = false
            TweenMax.to(el, 1, {
                alpha: 0,
                ease: Cubic.easeOut,
                onComplete: done
            })
        }
    }
}
</script>

<style src="styles/views/Auction.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/views/Auction.vue